import {Injectable} from '@angular/core';
import {MessageService} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private messageService: MessageService) {
  }

  errorToast(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Ошибка',
      detail: message ?? 'Серверная ошибка.',
      life: 10000,
    });
  }

  successToast(message?: string|null, summary?: string | null) {
    this.messageService.add({
      severity: 'success',
      summary: summary ?? 'Сообщение',
      detail: message ?? 'Действие выполнено успешно.',
      life: 10000,
    });
  }

}
